import {
  Input,
  Divider,
  Select,
  Col,
  Button,
  Table,
  Form,
  Modal,
  Spin,
} from "antd";
import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import MyInput from "../../Input";
import { useState, useRef, useEffect, useCallback } from "react";
import { Option } from "antd/es/mentions";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "antd/es/form/Form";
import MyButton from "../../Button";
import LoadMoreSelect from "../../LoadMoreSelect";
import {
  getConvertUoM,
  getListItemNew,
} from "../../../controllers/queue/createModal";
import { useDebounce } from "../../../utils/hooks/useDebounce";
import { errorNotification } from "../../Notification";
import ModalAddUom from "./addUOM";

const ModalAddProduct = (props) => {
  const { visible, onCancel, setTableData, tableData, recordItem,itemCate } = props;

  const isDesktop = useIsDesktop();
  const intl = useIntl();
  const [form] = Form.useForm();
  const product = Form.useWatch("product", form);
  const [triggers, setTrigger] = useState(false);
  const [productList, setProductList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [scrollProduct, setScrollProduct] = useState(10);
  const [searchProduct, setSearchProduct] = useState("");
  const debounch = useDebounce(searchProduct, 500);
  const [searchDataList, setSearchDataList] = useState([]);
  const { getFieldValue, getFieldsValue, setFieldsValue } = form;
  let isEdit = _.size(recordItem) > 0 ? "edit" : "create";
  const [uomaster, setUomMaster] = useState([]);
  const [visiBleAdd, setVisiBleAdd] = useState(false);
  const [searchUoM, setSearchUoM] = useState("");
  const [addNameUoM, setAddnameUoM] = useState("");
  const [loading, setLoading] = useState(false);
  const productItem = getFieldValue("product");

  console.log("searchDataList", uomaster);

  useEffect(() => {
    const getApi = async () => {
      const body = {
        itemBrandId: [],
        itemModelId: [],
        itemCode: "",
        itemName: "",
        limit: scrollProduct,
        page: 1,
        customerId: "",
        recently: false,
        recentlyModule: "deliveryOrderItem",
        categoryCode: "product",
        itemCodeBrandModelName: debounch,
        itemCategoryId: itemCate,
      };

      const response = await getListItemNew(body);
      console.log("PasTo", _.get(response, "data.data.itemList"));
      setLoading();
      setProductList(_.get(response, "data.data.itemList"));
    };

    getApi();
  }, [scrollProduct]);

  useEffect(() => {
    const getApi = async () => {
      const body = {
        itemBrandId: [],
        itemModelId: [],
        itemCode: "",
        itemName: "",
        limit: scrollProduct,
        page: 1,
        customerId: "",
        recently: false,
        recentlyModule: "deliveryOrderItem",
        categoryCode: "product",
        itemCodeBrandModelName: debounch,
        itemCategoryId: itemCate,
      };

      const response = await getListItemNew(body);
      console.log("DDDDDDDDD", _.get(response, "data.data.itemList"));

      setSearchDataList(_.get(response, "data.data.itemList"));
    };
    if (searchProduct && _.size(recordItem) <= 0 && visible) {
      getApi();
    }
  }, [debounch]);

  useEffect(() => {
    const getStockList = async () => {
      const unitData = await getConvertUoM(getFieldValue("product"));
      setUomList(_.get(unitData, "data.data"));
    };
    if (getFieldValue("product")) {
      getStockList();
    }
  }, [getFieldValue("product"), triggers]);

  const handleOnkeyPressNumber = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const setFieldEdit = () => {
      setFieldsValue({
        ["uom"]: _.get(recordItem, "uomId"),
        ["product"]: _.get(recordItem, "itemMasterId"),
        ["qty"]: _.get(recordItem, "qty"),
      });
    };
    if (_.size(recordItem) > 0 && visible && _.size(productList) > 0) {
      setFieldEdit();
    }
  }, [visible, productList]);

  useEffect(() => {
    const setUOMMaster = () => {
      const filterUom = _.get(
        _.filter(
          _.size(searchProduct) > 0 ? searchDataList : productList,
          (i) => {
            return i.itemMasterId === getFieldValue("product");
          }
        ),
        "[0]"
      );

      console.log("productItem", productItem);

      setUomMaster([
        {
          unit: _.get(filterUom, "unit"),
          uomId: _.get(filterUom, "uomId"),
          uomCategoryId: _.get(filterUom, "uomCategoryId"),
        },
      ]);
    };
    if (getFieldValue("product")) {
      setUOMMaster();
    }
  }, [getFieldValue("product")]);

  const layout = {
    wrapperCol: { span: 24 }, // กำหนดความกว้างของพื้นที่ที่บรรจุ Component
  };

  const handleSplitText = (value) => {
    const text = _.split(value, "·");
    // //console.log('SpliText',text);
    const filterName = text.slice(1).join(" ");
    return filterName ? filterName : value;
  };

  const handleZeroPrice = (rule, value, callback) => {
    if (value) {
      const parsValue = parseInt(value || 0);

      if (parsValue === 0) {
        callback(
          intl.formatMessage({
            id: "validateQtyThanZero",
            defaultMessage: "Qty must be greater than 0",
          })
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  const optionProduct = _.map(
    _.size(searchDataList) > 0 ? searchDataList : productList,
    (i) => {
      return (
        <Option
          label={
            _.get(i, "itemCode") +
            " " +
            // _.get(i, "itemBrandName") +
            // " " +
            // (_.get(i, "itemModelName") || "") +
            // " " +
            _.get(i, "itemName")
          }
          key={_.get(i, "itemMasterId")}
          value={_.get(i, "itemMasterId")}
        >
          {_.get(i, "itemCode") +
            " " +
            // _.get(i, "itemBrandName") +
            // " " +
            // // (_.get(i, "itemModelName") || "") +
            // " " +
            _.get(i, "itemName")}
        </Option>
      );
    }
  );

  const handleSearchitem = (value) => {
    console.log("VKVK", value);

    setSearchProduct(value);
  };

  const handleSaveitem = () => {
    console.log("getFieldsValue", getFieldsValue("product"));

    form
      .validateFields()
      .then(async (values) => {
        let tempData = [...tableData];

        const temprecord = _.filter(
          _.size(searchDataList) > 0 ? searchDataList : productList,
          (i) => {
            return _.get(values, "product") === i.itemMasterId;
          }
        );

        const record = _.get(temprecord, "[0]");

        const filterUOM = _.filter(uomList, (i) => {
          return _.get(values, "uom") === i.uomId;
        });

        const filterItem = _.filter(tableData, (i) => {
          return (
            _.get(record, "itemMasterId") === i.itemMasterId &&
            _.get(values, "uom") === i.uomId
          );
        });

        const filterItemCheckEdit = _.filter(tableData, (i) => {
          return (
            _.get(recordItem, "itemMasterId") === i.itemMasterId &&
            _.get(values, "uom") === i.uomId &&
            _.get(recordItem, "uomId") !== i.uomId
          );
        });

        const checkvalue =
          _.size(recordItem) > 0 &&
          _.get(recordItem, "uomId") !== _.get(values, "uom")
            ? true
            : false;

        if (checkvalue) {
          tempData = _.filter(tableData, (item) => {
            return (
              _.get(item, "itemMasterId") !== _.get(record, "itemMasterId") ||
              (_.get(item, "uomId") !== _.get(record, "uomId") &&
                _.get(item, "itemMasterId") === _.get(record, "itemMasterId"))
            );
          });
        }
        console.log(
          "FGFGFG",
          filterItem,
          "table: ",
          tableData,
          "value: ",
          record,
          "temp",
          tempData
        );

        console.log("FGFGI", tableData);

        if (_.size(filterItem) > 0 || _.size(recordItem) > 0) {
          if (_.size(recordItem) > 0 && _.size(filterItemCheckEdit) === 0) {
            tempData = _.map(tableData, (i) => {
              if (
                i.itemMasterId === _.get(recordItem, "itemMasterId") &&
                _.get(recordItem, "uomId") === i.uomId
              ) {
                return !checkvalue
                  ? {
                      ...i,
                      qty: parseInt(_.get(values, "qty")),
                    }
                  : {
                      ...i,
                      qty: _.get(values, "qty"),
                      uomId: _.get(values, "uom"),
                      uom: _.get(filterUOM, "[0].name"),
                    };
              } else {
                return i;
              }
            });
          } else {
            errorNotification(
              intl.formatMessage({
                id: "deliveryOrderQtyNoti",
                defaultMessage: "Have this order",
              })
            );
            return;
          }
        } else {
          tempData.push({
            itemMasterId: _.get(record, "itemMasterId"),
            itemCode: _.get(record, "itemCode"),
            itemName:
              (_.get(record, "itemBrandName") || "") +
              " " +
              (_.get(record, "itemModelName") || "") +
              " " +
              (_.get(record, "itemName") || ""),
            qty: _.get(values, "qty"),
            uomId: _.get(values, "uom"),
            uom: _.get(filterUOM, "[0].name"),
            index: _.size(tableData),
            statusCode: "open",
            shippingPrice: "0",
            itemBrandName: _.get(record, "itemBrandName"),
            itemModelName: _.get(record, "itemModelName"),
            row_id: _.size(tableData),
          });
        }

        console.log("TTTTT", tempData);

        setTableData(tempData);
        handleCancel();
      })
      .catch((info) => {
        errorNotification(
          intl.formatMessage({
            id: "saveErrorNotification",
            defaultMessage: "Failed",
          })
        );
      });
  };

  console.log("SAVESAVE", tableData);

  const openAdd = async (value) => {
    setAddnameUoM(value);
    setVisiBleAdd(true);
  };

  const closeAdd = () => {
    setVisiBleAdd(false);
  };

  const handleCancel = () => {
    onCancel();
    form.resetFields();
    setSearchProduct([]);
    setSearchDataList([]);
  };

  return (
    <Modal
      className={isDesktop ? "custom-modal" : undefined}
      style={{ marginTop: isDesktop ? "-50px" : null }}
      maskClosable={false}
      title={
        _.size(recordItem) > 0 ? (
          <>
            <Typography
              color={isDesktop ? COLORS.Purple : COLORS.GreenBrown}
              isBold
              size="16px"
              className={isDesktop ? "pb-0" : "text-center pb-2"}
            >
              <FormattedMessage
                id="ModalAddProductEditTitle"
                defaultMessage="แก้ไขสินค้า"
              />
            </Typography>
          </>
        ) : (
          <>
            <Typography
              color={isDesktop ? COLORS.Purple : COLORS.GreenBrown}
              isBold
              size="16px"
              className={isDesktop ? "pb-0" : "text-center pb-2"}
            >
              <FormattedMessage
                id="ModalAddProductCreateTitle"
                defaultMessage="เพิ่มสินค้า"
              />
            </Typography>
          </>
        )
      }
      open={visible}
      onOk={() => {}}
      onCancel={() => {
        handleCancel();
      }}
      width={680}
      centered={isDesktop ? true : false}
      footer={[
        isDesktop ? (
          <>
            <MyButton
              onClick={() => {
                handleCancel();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>
            <MyButton
              isPrimary
              onClick={() => {
                handleSaveitem();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnSave" defaultMessage="Save" />
            </MyButton>
          </>
        ) : (
          <div style={{ marginTop: "-12px" }}>
            <MyButton
              isPrimary
              onClick={() => {
                handleSaveitem();
              }}
              style={{
                width: isDesktop ? "25%" : "100%",
                marginBottom: "10px",
              }}
            >
              <FormattedMessage id="btnSave" defaultMessage="Save" />
            </MyButton>
            <MyButton
              onClick={() => {
                handleCancel();
              }}
              style={{
                width: isDesktop ? "25%" : "100%",
                marginLeft: "0px",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>
          </div>
        ),
      ]}
    >
      <div
        className="d-flex flex-column py-1 m-2"
        // style={{ height: "calc(100vh - 667px)" }}
        style={{ height: "160px" }}
      >
        <Form {...layout} form={form}>
          <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"} `}>
            <Col className="px-0" span={24}>
              <div className="w-100">
                <div className="d-flex align-items-center pb-1">
                  <Typography color={COLORS.Purple} className="pb-1">
                    <FormattedMessage
                      id="ModalAddProductCreateProduct"
                      defaultMessage="สินค้า"
                    />
                  </Typography>
                  <Typography
                    isBold
                    size="14px"
                    color={COLORS.Error}
                    className="pl-2"
                  >
                    *
                  </Typography>
                </div>
                <Form.Item
                  name="product"
                  rules={[
                    {
                      required: true,
                      message: (
                        <FormattedMessage
                          id="ModalAddProductCreateProductVD"
                          defaultMessage="กรุณาเลือกสินค้า"
                        />
                      ),
                    },
                  ]}
                >
                  <LoadMoreSelect
                    disabled={_.size(recordItem) > 0 ? true : false}
                    data={
                      _.size(searchDataList) > 0 ? searchDataList : productList
                    }
                    // data={searchDataList}
                    optionData={optionProduct}
                    onChange={() => {}}
                    onSelect={() => {}}
                    handleSearchitem={handleSearchitem}
                    setScrollProduct={setScrollProduct}
                    scrollProduct={scrollProduct}
                    placeHolder={intl.formatMessage({
                      id: "ModalAddProductCreateProductPH",
                      defaultMessage: "เลือกสินค้า",
                    })}
                    value={
                      _.size(recordItem) > 0 && _.size(productList) > 0
                        ? getFieldValue("product")
                        : undefined
                    }
                  />
                </Form.Item>
              </div>
            </Col>
            <div className="mr-4" />
          </div>

          <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"}`}>
            <Col className="px-0" span={isDesktop ? 11 : 24}>
              <Form.Item
                name="qty"
                rules={[
                  {
                    required: getFieldValue("type") === "TAS-DO" ? false : true,
                    message: (
                      <FormattedMessage
                        id="ModalAddProductCreateQtyVD"
                        defaultMessage="กรุณาระบุจำนวน"
                      />
                    ),
                  },
                  {
                    validator: handleZeroPrice,
                  },
                ]}
              >
                <MyInput
                  isRequired
                  label={
                    <FormattedMessage
                      id="ModalAddProductCreateQty"
                      defaultMessage="จำนวน"
                    />
                  }
                  placeHolder={intl.formatMessage({
                    id: "ModalAddProductCreateQtyPH",
                    defaultMessage: "ระบุจำนวน",
                  })}
                  className="w-100"
                  onKeyPress={handleOnkeyPressNumber}
                />
              </Form.Item>
            </Col>
            <div className="mr-4" />

            <Col className="px-0" span={isDesktop ? 12 : 24}>
              <div className="w-100">
                <div className="d-flex align-items-center pb-1">
                  <Typography color={COLORS.Purple} className="pb-1">
                    <FormattedMessage
                      id="ModalAddProductCreateUnit"
                      defaultMessage="หน่วย"
                    />
                  </Typography>
                  <Typography
                    isBold
                    size="14px"
                    color={COLORS.Error}
                    className="pl-2"
                  >
                    *
                  </Typography>
                </div>
                <Form.Item
                  name="uom"
                  //   initialValue="TAS-DO"
                  rules={[
                    {
                      required: true,
                      message: (
                        <FormattedMessage
                          id="ModalAddProductCreateUnitVD"
                          defaultMessage="กรุณาระบุหน่วย"
                        />
                      ),
                    },
                  ]}
                >
                  <Select
                    disabled={product ? false : true}
                    className="w-100"
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder={intl.formatMessage({
                      id: "ModalAddProductCreateUnitPH",
                      defaultMessage: "ระบุหน่วย",
                    })}
                    onSearch={(e) => {
                      setSearchUoM(e);
                      console.log("OOOOO", e);
                    }}
                    onChange={(e) => {}}
                    onSelect={(e) => {}}
                    optionLabelProp="label"
                    notFoundContent={
                      <div
                        style={{ cursor: "pointer", color: COLORS.Dark }}
                        onClick={() => {
                          // openAdd(searchUoM);
                        }}
                      >
                        {searchUoM}
                      </div>
                    }
                  >
                    {uomList &&
                      _.map(uomList, (item, index) => {
                        return (
                          <Option
                            label={_.get(item, "name")}
                            key={_.get(item, "uomId")}
                            value={_.get(item, "uomId")}
                          >
                            {_.get(item, "name")}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </div>
            </Col>
          </div>
        </Form>
      </div>

      <ModalAddUom
        visible={visiBleAdd}
        onCancel={closeAdd}
        uomaster={uomaster}
        setTrigger={setTrigger}
        addNameUoM={addNameUoM}
        uomList={uomList}
      />
    </Modal>
  );
};

export default ModalAddProduct;
